import { AddDiv, InsertDomElementBefore } from '../engine/viewer/domutils.js';
import { Settings } from './settings.js';
import { SidebarPanel } from './sidebarpanel.js';
import { Loc } from '../engine/core/localization.js';
import { GetComments } from './comments.js';

import '@simonwep/pickr/dist/themes/monolith.min.css';
import $ from 'jquery';


class SettingsSection
{
    constructor (parentDiv, title, settings)
    {
        this.parentDiv = parentDiv;
        this.contentDiv = AddDiv (this.parentDiv, 'ov_sidebar_settings_section');
        this.headerDiv = AddDiv (this.contentDiv, 'ov_sidebar_title', title);
        this.settings = settings;
        this.callbacks = null;
    }

    Init (callbacks)
    {
        this.callbacks = callbacks;
    }

    Update ()
    {

    }

    UpdateVisibility ()
    {

    }

    Clear ()
    {

    }
	
	Show()
	{
		this.contentDiv.classList.remove('ov_comment_sidebar_section_hidden');
	}
	
	Hide()
	{
		this.contentDiv.classList.add('ov_comment_sidebar_section_hidden');
	}
}

class CommentsSection extends SettingsSection
{
    constructor (parentDiv, settings)
    {
        super (parentDiv, Loc ('Model comments'), settings);
		this.items = [];
    }

    Init (callbacks)
    {
        super.Init (callbacks);
    }

    Update ()
    {

    }

    UpdateVisibility ()
    {

    }

    Clear ()
    {
		this.items.forEach( item => { 
			$(item).remove(); 
		} );
		this.items = [];
    }
	
	LoadComments()
	{
		const comments = GetComments();
		for (let i = 0; i < comments.length; i++) 
		{
			let cDiv = AddDiv (this.contentDiv, 'ov_sidebar_parameter ov_sidebar_comment', comments[i].name);
			this.items.push(cDiv);
			$(cDiv).data('uid', comments[i].uid);
			
			$(cDiv).on('click', comments[i], (event)=>{
				
				if (this.callbacks && this.callbacks.onSelectComment) 
				{
					this.callbacks.onSelectComment(event.data);
				}
				
			});
		}
	}
}

class SelectedCommentSection extends SettingsSection
{
    constructor (parentDiv, settings)
    {
        super (parentDiv, '', settings);
		this.headerDiv.classList.add('ov_selected_comment_section_flex');
		this.backButton = AddDiv(this.headerDiv, 'ov_button ov_dialog_button outline ov_comment_sidebar_section_back', Loc ('Back'));
		this.titleDiv = AddDiv(this.headerDiv, 'ov_sidebar_title ov_sidebar_title_advanced', '');
		this.descriptionDiv = AddDiv(this.contentDiv, '');
		this.timeDiv = AddDiv(this.contentDiv, '');
		// A note kept with the model is a note somebody has to be able to
		// take off it again.
		this.comment = null;
		this.deleteButton = AddDiv(this.contentDiv, 'ov_sidebar_comment_delete', Loc ('Delete comment'));
		$(this.deleteButton).on('click', ()=>{
			if (this.comment !== null && this.callbacks && this.callbacks.onDelete)
			{
				this.callbacks.onDelete(this.comment);
			}
		});
		InsertDomElementBefore(this.backButton, this.titleDiv);
		$(this.backButton).on('click', ()=>{
			this.callbacks.onGoBack();
		});
    }

    Init (callbacks)
    {
        super.Init (callbacks);
    }

    Update ()
    {

    }

    UpdateVisibility ()
    {

    }

    Clear ()
    {

    }
	
	LoadCommentInfo(comment)
	{
		this.comment = comment;
		this.titleDiv.innerText = comment.name;
		this.descriptionDiv.innerText = comment.text;
		
		this.timeDiv.innerHTML = '<br /><br /><br /><br />'+new Date(comment.time).toLocaleString('en-GB', { hour12: false });
	}
}

export class SidebarCommentsPanel extends SidebarPanel
{
    constructor (parentDiv, settings)
    {
        super (parentDiv);
        this.settings = settings;

        this.sectionsDiv = AddDiv (this.contentDiv, 'ov_sidebar_settings_sections ov_thin_scrollbar');
        this.modelCommentsSection = new CommentsSection (this.sectionsDiv, this.settings);
		this.selectedCommentSection = new SelectedCommentSection(this.sectionsDiv, this.settings);
		
		this.modelCommentsSection.Show();
		this.selectedCommentSection.Hide();
    }

    GetName ()
    {
        return Loc ('Comments');
    }
	
	GetType ()
	{
		return 'comments';
	}
	
	LoadComments()
	{
		this.Clear();
		setTimeout(()=>{
			this.modelCommentsSection.LoadComments();
		}, 500);
	}

    HasTitle ()
    {
        return false;
    }

    GetIcon ()
    {
        return 'feedback';
    }

    Clear ()
    {
        this.modelCommentsSection.Clear ();
    }

    Init (callbacks)
    {
        super.Init (callbacks);

        this.modelCommentsSection.Init ({
			onSelectComment: (data) => {
				this.modelCommentsSection.Hide();
				this.selectedCommentSection.LoadCommentInfo(data);
				this.selectedCommentSection.Show();
				this.callbacks.onSelectComment(data);
			}
        });
		this.selectedCommentSection.Init({
			onGoBack: () => {
				this.callbacks.onSidebarCommentGoBack();
				this.selectedCommentSection.Hide();
				this.modelCommentsSection.Show();
			},
			onDelete: (comment) => {
				this.selectedCommentSection.Hide();
				this.modelCommentsSection.Show();
				this.callbacks.onDeleteComment(comment.uid);
			}
		});

    }

    UpdateControlsStatus ()
    {
        this.modelCommentsSection.Update ();
    }

    UpdateControlsVisibility ()
    {
        this.modelCommentsSection.UpdateVisibility ();
        this.Resize ();
    }

    ResetToDefaults ()
    {
        let defaultSettings = new Settings (this.settings.themeId);

        this.settings.themeId = defaultSettings.themeId;
        this.UpdateControlsStatus ();
    }

    Resize ()
    {

    }
}
